import { baseAPI } from '@/api/axios';
import { generateUrl } from '@/utils/helpers';

const getOptions = (
  tenantId,
  groupId = null,
  contentType = 'application/json'
) => {
  const headers = { 'Content-Type': contentType };
  if (tenantId) headers['TenantId'] = tenantId;
  if (groupId) headers['Group-Id'] = groupId;
  return { headers };
};

export default {
  getAllOrganizations(payload) {
    const url = generateUrl('organization/', payload);
    return baseAPI.get(url);
  },
  getOrganizationDetail(orgId) {
    return baseAPI.get(`organization/${orgId}`);
  },
  addOrganization(payload) {
    return baseAPI.post('organization/', payload);
  },
  updateOrganization({ orgId, payload }) {
    return baseAPI.post(`organization/${orgId}`, payload);
  },
  generateProfileImageUploadUrl({ orgId, payload }) {
    return baseAPI.post(
      `organization/${orgId}/generateProfileImageUploadUrl`,
      payload
    );
  },
  deleteProfileImage(orgId) {
    return baseAPI.delete(`organization/${orgId}/profileImage`);
  },
  getOrgCourses({ orgId, payload }) {
    const url = generateUrl(`organization/${orgId}/accessRecords`, payload);
    return baseAPI.get(url, getOptions(orgId));
  },
  updateOrgCourseAccess({
    orgId,
    courseId,
    active,
    assignableCourseOverrideId = null,
    licenseExpiration,
    numberOfLicenses,
  }) {
    return baseAPI.post(
      `organization/${orgId}/accessRecords/${courseId}`,
      {
        active,
        ...(assignableCourseOverrideId && { assignableCourseOverrideId }),
        licenseExpiration,
        numberOfLicenses,
      },
      getOptions(orgId)
    );
  },
  getFeedbacks(payload) {
    const url = generateUrl('/feedback', payload);
    return baseAPI.get(url);
  },
  getFeedbackSummary() {
    const url = generateUrl('/feedback/summary');
    return baseAPI.get(url);
  },
  getViolations(payload) {
    const url = generateUrl('/violations/users/lockedOut', payload);
    return baseAPI.get(url);
  },
  getViolationMetrics(payload) {
    const url = generateUrl('/violations/metrics', payload);
    return baseAPI.get(url);
  },
  getViolationsNotified() {
    return baseAPI.get('/violations/notified');
  },
  changeViolationNotifyStatus(payload) {
    return baseAPI.post('/violations/changeNotifyStatus', payload);
  },
  getViolationEvents(payload) {
    const url = generateUrl('/violations', payload);
    return baseAPI.get(url);
  },
  shareViolation(id, payload) {
    return baseAPI.post(`/violations/${id}/share`, payload);
  },
  getViolationById(id) {
    return baseAPI.get(`/violations/${id}`);
  },
  getUniqueLoggedBrowsersAndDevices() {
    return baseAPI.get('/assets/uniqueLoggedBrowsersAndDevices');
  },
  getViolationFilters() {
    return baseAPI.get('/violationFilters/forCurrentUser');
  },
  getViolationFilterById(filterId) {
    return baseAPI.get(`/violationFilters/${filterId}`);
  },
  saveViolationFilter(payload) {
    return baseAPI.post('/violationFilters', payload);
  },
  updateViolationFilter(payload) {
    return baseAPI.post(`/violationFilters/${payload.id}`, payload);
  },
  deleteViolationFilter(id) {
    return baseAPI.delete(`/violationFilters/${id}`);
  },
  blacklistSearch(payload) {
    const url = generateUrl('/blacklist/search', payload);
    return baseAPI.get(url);
  },
  blacklistBlock(payload) {
    return baseAPI.post('/blacklist/block', payload);
  },
  blacklistUnblock(payload) {
    return baseAPI.post('/blacklist/unblock', payload);
  },
  unlockViolation(payload) {
    return baseAPI.post('/violations/unlockTerms', payload);
  },
  getCourseUrlTypes(payload) {
    return baseAPI.get('/courseUrlTypes/list', payload);
  },

  // Messaging platform
  getMessageDistributionLists(payload) {
    const url = generateUrl('/AppMessageDistributionLists', payload);
    return baseAPI.get(url);
  },
  getMessageDistributionListsById(id) {
    const url = generateUrl(`AppMessageDistributionLists/${id}`);
    return baseAPI.get(url);
  },
  getNumberOfAffectedUsers(payload) {
    return baseAPI.post('/AppMessageDistributionLists/affectedUsers', payload);
  },
  createMessageDistributionList(payload) {
    return baseAPI.post('/AppMessageDistributionLists', payload);
  },
  updateMessageDistributionList(id, payload) {
    return baseAPI.post(`/AppMessageDistributionLists/${id}`, payload);
  },
  deleteMessageDistributionLists(id) {
    return baseAPI.delete(`/AppMessageDistributionLists/${id}`);
  },
  createAppMessage(payload) {
    return baseAPI.post('/AppMessages', payload, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });
  },
  getAppMessageById(id) {
    return baseAPI.get(`/AppMessages/${id}`);
  },
  updateAppMessageById(id, payload) {
    return baseAPI.post(`/AppMessages/${id}`, payload, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });
  },
  deleteAppMessage(id) {
    return baseAPI.delete(`/AppMessages/${id}`);
  },
  getPendingMessages() {
    return baseAPI.get('/AppMessages/pending');
  },
  getReleasedMessages(payload) {
    return baseAPI.post('/AppMessages/search', payload);
  },
  uploadFaq(payload) {
    return baseAPI.post('/Assets/uploadFaq', payload, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });
  },
  getAccreditingEntities() {
    return baseAPI.get('/AccreditingEntities');
  },
};
